/* *********************************************************************** */

/*
 * 'Load more' button: AJAX content fetcher and fade in
 *
 *  USAGE:
 *
 *  Define a content div which should be used to append additional content
 *  into. Create a <button>, assign class .ajaxLoadMore to it and provide
 *  data-target and data-content:
 *
 *  data-target="#someDiv" is the target container into which the loaded
 *  content should be inserted.
 *
 *  data-content="contentId" is the HTTP ajax=contentId GET parameter
 *  which Neos uses to decide which content to deliver.
 *
 *  TODO: data-offset="10" defines the offset size (number of entries delivered per click action).
 */

$(function () {

    var ajaxCurrentOffset = 10;

    $("#ajaxLoadMore").click(function (event) {

        var $this = $(this);

        event.preventDefault();

        var language = $this.data("language") || "";
        var url = $this.data("url") || "/" + language;
        var target = $this.data("target");
        var content = $this.data("content");

        $this.button("loading");

        $.get(url, {ajax: content, offset: ajaxCurrentOffset}).done(function (html) {

            $(target).append("<div class=\"ajax-fade-" + ajaxCurrentOffset + "\" style=\"display:none;\">" + html + "</div>");

            $(".ajax-fade-" + ajaxCurrentOffset).fadeIn(2000);

            ajaxCurrentOffset += 10;

            $.get(url, {ajax: content, offset: ajaxCurrentOffset}).done(function (html) {
                if (!html) {

                    $this.hide();

                } else {

                    $this.button("reset");

                }
            });

        });

    });

});
